import React from 'react'
import Phonecall from "../../Images/phoencalimage.png"
import Address from "../../Images/adressimage.png"
import Emailimage from "../../Images/emailimage.png"
import HomeNavbar from './HomeNavbar'
import Footer from './Footer'

function RefundAndCancle() {
  return (
   <>
   <HomeNavbar />
      <div
          id="faqs-page"
          className="bg-white w-full py-20  text-center font-oswald mt-10"
        >
          <div className=" flex items-center justify-center">
            <p
              style={{ backgroundColor: "#EFEEFE" }}
              className="  rounded-full py-2 px-6 font-bold text-bgBlue"
            >
             R&C
            </p>
          </div>
          <br />
          <h2 className="text-3xl font-bold text-gray-900  animate-fade-in">
            Refund &<span className="text-purple">  Cancellation </span>{" "}
          </h2>
         
         

         <div className='lg:w-3/4 m-auto shadow-xl'>
         <div className="text-bgBlue p-8">
      <div className="text-start">
        <h1 className="text-4xl font-bold mb-4">Refund and Cancellation Policy</h1>
        <p className="mb-4">Effective Date: 30 Nov 2025</p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Introduction</h2>
          <p className="mb-2">
            This Refund and Cancellation Policy outlines the circumstances under
            which Learn2Earn24x7 offers refunds and how users can request a refund or
            cancel their participation in a paid activity. By using our services,
            you agree to this policy.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Eligibility for Refunds</h2>
          <p className="mb-2">
            Refunds are only available under certain conditions as outlined
            below. Please read these conditions carefully before making any
            purchase or payment on our platform.
          </p>
          <ul className="list-disc ml-6 mb-2">
            <li className="mb-2">
              <strong>Technical Issues:</strong> If you experience a technical
              issue that prevents you from accessing a paid feature or service,
              you may be eligible for a refund. Please report the issue within 24
              hours of the payment.
            </li>
            <li className="mb-2">
              <strong>Service Unavailability:</strong> If a paid service or
              feature becomes unavailable due to an error or malfunction on our
              part, you may request a refund for the portion of the service you
              were unable to use.
            </li>
            <li className="mb-2">
              <strong>Incorrect Charges:</strong> If you believe you were charged
              incorrectly, please contact us immediately. After investigation, if
              the charge is found to be incorrect, we will issue a refund.
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Non-Refundable Items</h2>
          <p className="mb-2">
            Certain items and services are non-refundable, including but not
            limited to:
          </p>
          <ul className="list-disc ml-6 mb-2">
            <li className="mb-2">
              Participation fees for challenges or competitions that have already
              started.
            </li>
            <li className="mb-2">
              Digital products, such as study materials or question sets, once
              accessed or downloaded.
            </li>
            <li className="mb-2">
              Subscription fees for periods where the service was fully
              available.
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Cancellation Policy</h2>
          <p className="mb-2">
            You may cancel your participation in a paid activity before it begins
            to be eligible for a refund. Once an activity has started, cancellations
            are not allowed, and no refunds will be provided.
          </p>
          <p className="mb-2">
            For subscription services, you may cancel at any time, but refunds
            will not be provided for the remaining period of the subscription. The
            service will continue until the end of the current billing cycle.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">How to Request a Refund</h2>
          <p className="mb-2">
            To request a refund, please contact our support team at{" "}
            <a
              href="mailto:support@learn2earn24x7.com"
              className="text-blue-500 underline"
            >
              support@learn2earn24x7.com
            </a>
            . Include your name, email address, and details of the purchase in
            question. Refund requests will be processed within 48 working hours
            of receipt.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Processing of Refunds</h2>
          <p className="mb-2">
            Approved refunds will be credited back to the original payment method
            within 48 working hours after approval. Please note that it may
            take additional time for the refund to appear on your statement,
            depending on your financial institution.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Changes to This Policy</h2>
          <p className="mb-2">
            Learn2Earn24x7 reserves the right to modify this Refund and Cancellation
            Policy at any time. We will notify users of significant changes by
            email or through our app. Your continued use of the service after
            such changes signifies your acceptance of the new policy.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Contact Information</h2>
          <p className="mb-2">
            If you have any questions about this Refund and Cancellation Policy,
            please contact us at{" "}
            <a
              href="mailto:support@learn2earn24x7.com"
              className="text-blue-500 underline"
            >
              support@learn2earn24x7.com
            </a>
            .
          </p>
        </section>
      </div>
    </div>
         </div>
        </div>
        <Footer/>
   </>
  )
}

export default RefundAndCancle
